import React, { PureComponent } from 'react'
import { OverlayTrigger, Table, Tooltip, Button } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import LegalCompanyModalPage from '../../../containers/masters/LegalCompany/LegalCompanyModalPage'
import InputText from '../../commons/form/InputText'
import IDocCarPagination from '../../commons/iDocCarPagination'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'
class LegalCompanyMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchCif: null,
        searchDescription: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchLegalCompanyList(null)
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchLegalCompanyList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchLegalCompanyList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleCifChange (searchCif) {
    if (this.state.filter.searchCif !== searchCif) {
      this.setState({ filter: { ...this.state.filter, searchCif } })
    }
  }

  handleDescriptionChange (searchDescription) {
    if (this.state.filter.searchDescription !== searchDescription) {
      this.setState({ filter: { ...this.state.filter, searchDescription } })
    }
  }

  searchLegalCompanyList () {
    this.props.actions.fetchLegalCompanyList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchCif: null,
        searchDescription: null
      }
    }, () => { this.searchLegalCompanyList() })
  }

  render () {
    const {
      t, legalCompanyList, pagesCount, legalCompanyCount, filter,
      filter: { page },
      actions: { openLegalCompanyModal, deleteLegalCompanyModal, fetchLegalCompanyList }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'legalCompanyMasterPage' })
    const tKey = 'MASTERS.LEGAL_COMPANY_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const hasFilters = (this.state.filter.searchCif || this.state.filter.searchDescription)
    return (
      <div id='legalCompanyMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openLegalCompanyModal()}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.cif"
                controlLabel={t(`${tKey}CIF`)}
                placeholder={t(`${tKey}CIF`)}
                onInputChange={(value) => this.handleCifChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.description"
                controlLabel={t(`${tKey}DESCRIPTION`)}
                placeholder={t(`${tKey}DESCRIPTION`)}
                onInputChange={(value) => this.handleDescriptionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchLegalCompanyList()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t('ADMIN.SEARCH_BTN')}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {legalCompanyList.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th
                        onClick={() => { this.changeOrder('legalCompanyId') }}
                      >
                        {t('MASTERS.ID')}
                        <i className={this.getSortIcon(t('MASTERS.ID'))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('description') }}
                      >
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon(t(`${tKey}DESCRIPTION`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('cif') }}
                      >
                        {t(`${tKey}CIF`)}
                        <i className={this.getSortIcon(t(`${tKey}CIF`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('commercialRegistry') }}
                      >
                        {t(`${tKey}COMERCIAL_REGISTRY`)}
                        <i className={this.getSortIcon(t(`${tKey}COMERCIAL_REGISTRY`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('brand') }}
                      >
                        {t(`${tKey}BRAND`)}
                        <i className={this.getSortIcon(t(`${tKey}BRAND`))} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {legalCompanyList && legalCompanyList.map((legal, idx) => (
                      <tr key={idx}>
                        <td>{legal.legalCompanyId}</td>
                        <td>{legal.description}</td>
                        <td>{legal.cif}</td>
                        <td>{legal.commercialRegistry}</td>
                        <td>{legal.brand}</td>
                        <td className='actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openLegalCompanyModal(legal.legalCompanyId)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteLegalCompanyModal(legal.legalCompanyId)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
              {(legalCompanyList === null || legalCompanyList === undefined || legalCompanyList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_legal_company"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={legalCompanyCount}
                    onSelectAction={(value) => fetchLegalCompanyList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <LegalCompanyModalPage />
      </div>

    )
  }
}

export default reduxForm({
  form: 'listLegalCompanyMaster'
})(LegalCompanyMaster)
